// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'DM Mono', monospace;
}
.banner {
  background: black;
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Long Cang";
  font-size: 50px;
}
.banner .banner-text-c {
  color: #00ffe5;
}
code {
  font-family: 'DM Mono', monospace;
}
.text {
  margin: 20px auto;
  font-family: Rubik, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  max-width: 95vw;
}
.text td {
  padding: 15px;
  background: whitesmoke;
  color: #000000;
}
code {
  background: #ececec;
  /* border-radius: 4px; */
  padding: 1px 5px;
}
.component-name,
.example-title {
  background: #000000;
  color: yellow;
  padding: 10px 15px;
  font-family: Rubik, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 900;
  font-size: 1.75em;
  width: fit-content;
}
.example-title {
  background: #000000;
  color: #00ffe5;
}
.nav-content-root {
  max-width: 900px;
}
.header-icons {
  position: absolute;
  right: 0px;
  padding-right: 20px;
}
.icon svg {
  color: white;
  margin: 20px;
}
.icon:hover svg {
  fill: #4d4d4d;
}
.nav-context {
  justify-content: center;
}
.nav-content {
  margin-bottom: 100px;
}
blockquote {
  background: #e4e4e4;
  padding: 2px 40px;
  border-radius: 10px;
}
pre {
  background: #23241f;
  tab-size: 30px;
  box-sizing: border-box;
  font-family: 'DM Mono';
  padding: 20px;
  margin: 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 5px;
}
.example-code {
  position: relative;
  max-width: 100vw;
  padding: 5px;
  display: flex;
  flex-direction: column;
  background: black;
  box-sizing: border-box;
  margin: 20px auto;
  margin-top: -5px;
  overflow: hidden;
}
.example-code .scroll {
  min-height: 300px;
}
.example-code .lang-select-box {
  background: black;
  overflow: hidden;
  display: flex;
}
.example-code .lang-select-box .lang-select-button {
  padding: 8px 10px;
  cursor: pointer;
  outline: none;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: grey;
}
.example-code .lang-select-box .lang-select-button.select {
  background: #00ffe5;
  color: black;
}
.example-code .lang-select-box .lang-select-button.select:hover {
  color: black;
}
.example-code .lang-select-box .lang-select-button:hover {
  color: white;
}
.example-render {
  width: -webkit-fill-available;
  height: 360px;
  position: relative;
  background: linear-gradient(45deg, #00aeff 0%, hsl(287, 100%, 61%) 100%);
  border: 5px solid black;
}
hr {
  border-radius: 4px;
  border: 2px solid #e4e4e4;
}
`, "",{"version":3,"sources":["webpack://./docs-site/main.less"],"names":[],"mappings":"AACA;EACC,iCAAA;AAAD;AAGA;EACC,iBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;AADD;AAPA;EAUE,cAAA;AAAF;AAIA;EACC,iCAAA;AAFD;AAKA;EACC,iBAAA;EAEA,gIAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAJD;AAHA;EASE,aAAA;EACA,sBAAA;EACA,cAAA;AAHF;AAQA;EACC,mBAAA;EANC,wBAAwB;EAQtB,gBAAA;AANJ;AAUA;;EACC,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,+IAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPD;AAUA;EACC,mBAAA;EACA,cAAA;AARD;AAWA;EACC,gBAAA;AATD;AAaA;EACC,kBAAA;EACA,UAAA;EACA,mBAAA;AAXD;AAcA;EAEE,YAAA;EACA,YAAA;AAbF;AAgBC;EAEE,aAAA;AAfH;AAoBA;EACC,uBAAA;AAlBD;AAqBA;EACC,oBAAA;AAnBD;AAsBA;EACC,mBAAA;EACG,iBAAA;EACA,mBAAA;AApBJ;AAsBA;EACC,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AApBD;AAuBA;EACC,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACG,sBAAA;EACH,iBAAA;EACA,gBAAA;EACA,gBAAA;AArBD;AAWA;EAYE,iBAAA;AApBF;AAQA;EAiBE,iBAAA;EACA,gBAAA;EAEA,aAAA;AAvBF;AAGA;EAsBG,iBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAtBH;AAyBG;EACC,mBAAA;EACA,YAAA;AAvBJ;AAwBI;EACC,YAAA;AAtBL;AAyBG;EACC,YAAA;AAvBJ;AA6BA;EACC,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,wEAAA;EACA,uBAAA;AA3BD;AA8BA;EACC,kBAAA;EACG,yBAAA;AA5BJ","sourcesContent":["\nbody{\n\tfont-family: 'DM Mono', monospace;\n}\n\n.banner{\n\tbackground: black;\n\tcolor: white;\n\tpadding: 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-family: \"Long Cang\";\n\tfont-size: 50px;\n\t.banner-text-c{\n\t\tcolor: rgb(0, 255, 229);\n\t}\n}\n\ncode{\n\tfont-family: 'DM Mono', monospace;\n}\n\n.text{\n\tmargin: 20px auto;\n\t// font-family: \"Nunito\", system-ui;\n\tfont-family: Rubik, -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;\n\tfont-weight: 400;\n\tfont-size: 18px;\n\tline-height: 140%;\n\tmax-width: 95vw;\n\ttd{\n\t\tpadding: 15px;\n\t\tbackground: whitesmoke;\n\t\tcolor: rgb(0, 0, 0);\n\t\t// border: 1px solid black;\n\t}\n\t\n}\ncode{\n\tbackground: #ececec;\n    /* border-radius: 4px; */\n    padding: 1px 5px;\n\n}\n\n.component-name,.example-title{\n\tbackground: rgb(0, 0, 0);\n\tcolor: yellow;\n\tpadding: 10px 15px;\n\tfont-family: Rubik, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n\tfont-weight: 900;\n\tfont-size: 1.75em;\n\twidth: fit-content;\n}\n\n.example-title{\n\tbackground: rgb(0, 0, 0);\n\tcolor: rgb(0, 255, 229);\n}\n\n.nav-content-root{\n\tmax-width: 900px;\n\t\n}\n\n.header-icons{\n\tposition: absolute;\n\tright: 0px;\n\tpadding-right: 20px;\n}\n\n.icon{\n\tsvg{\n\t\tcolor: white;\n\t\tmargin: 20px;\n\t}\n\t\n\t&:hover{\n\t\tsvg{\n\t\t\tfill: rgb(77, 77, 77);\n\t\t}\n\t}\n}\n\n.nav-context{\n\tjustify-content: center;\n}\n\n.nav-content{\n\tmargin-bottom: 100px;\n\t// border-bottom: 2px solid black;\n}\nblockquote{\n\tbackground: #e4e4e4;\n    padding: 2px 40px;\n    border-radius: 10px;\n}\npre{\n\tbackground: #23241f;\n\ttab-size: 30px;\n\tbox-sizing: border-box;\n\tfont-family: 'DM Mono';\n\tpadding: 20px;\n\tmargin: 0px;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 150%;\n\tmargin-top: 5px;\n}\n\n.example-code{\n\tposition: relative;\n\tmax-width: 100vw;\n\tpadding: 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: black;\n    box-sizing: border-box;\n\tmargin: 20px auto;\n\tmargin-top: -5px;\n\toverflow: hidden;\n\t.scroll{\n\t\tmin-height: 300px;\n\t}\n\t\n\t.lang-select-box{\n\t\t\n\t\tbackground: black;\n\t\toverflow: hidden;\n\t\t\n\t\tdisplay: flex;\n\t\t.lang-select-button{\n\t\t\tpadding: 8px 10px;\n\t\t\tcursor: pointer;\n\t\t\toutline: none;\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tcolor: grey;\n\t\t\t\n\t\t\t// font-size: 14px;\n\t\t\t&.select{\n\t\t\t\tbackground: rgb(0, 255, 229); //linear-gradient(45deg, #4affed, #00d9ff);\n\t\t\t\tcolor: black;\n\t\t\t\t&:hover{\n\t\t\t\t\tcolor: black;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\tcolor: white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.example-render{\n\twidth: -webkit-fill-available;\n\theight: 360px;\n\tposition: relative;\n\tbackground: linear-gradient(45deg, rgb(0, 174, 255) 0%, hsl(287, 100%, 61%) 100%);\n\tborder: 5px solid black;\n}\n\nhr{\n\tborder-radius: 4px;\n    border: 2px solid #e4e4e4;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
